module.exports = __webpack_public_path__ + "static/mesh-bg-vertical-dl-6fa5a5d2fdb4ea4f335b4d1dcd8559e0.png";